<template>
    <div :class="['feedback-form', {'success': status == 'success'}]">
        <form class="wrap" @submit.prevent="submitForm">
            <div class="form-group margin-bottom-none">
                <label class="label">{{ $t__('On a scale of 0-10, how likely is it that you would recommend Pixenio to a friend or colleague?') }}</label>

                <div class="rating">
                    <label class="radio-block custom" v-for="n in 11" :key="n-1">
                        <input
                            type="radio"
                            name="rating"
                            :value="n-1"
                            v-model="rating"
                        >
                        <div class="number">
                            {{ n-1 }}
                        </div>
                    </label>
                </div>
            </div>

            <div class="columns is-mobile is-spaced is-gapless margin-bottom-none margin-top-half rating-labels">
                <div class="column">
                    {{ $t__('Not likely at all') }}
                </div>

                <div class="column align-center">
                    {{ $t__('Neutral') }}
                </div>

                <div class="column align-right">
                    {{ $t__('Extremely likely') }}
                </div>
            </div>

            <div class="form-group margin-bottom-none margin-top-1">
                <label class="label">{{ $t__('What is the primary reason of your score?') }}</label>

                <div class="answer margin-bottom-text">
                    <textarea name="answer" rows="2" ref="answer" v-model="answer" required></textarea>
                </div>

                <height-transition>
                    <div class="notification negative" v-show="status == 'error'">{{ $t__('Something went wrong. Please try again later.') }}</div>
                </height-transition>

                <button type="submit" :class="['btn positive', {'is-loading': status == 'sending'}]">{{ $t__('Submit Rating') }}</button>
            </div>
        </form>

        <div class="overlay" v-if="status == 'success'">
            <span class="text">{{ $t__('Thank you for your feedback!') }}</span>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'FeedbackForm',

        data: () => ({
            rating: null,
            answer: "",
            status: ""
        }),

        watch: {
            rating() {
                this.focusAnswer();
            }
        },

        methods: {
            focusAnswer() {
                this.$refs.answer.focus();
            },

            getData() {
                return {
                    rating: this.rating,
                    content: this.answer
                }
            },

            submitForm() {
                this.status = "sending";

                axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

                axios.post('/admin/ajax/feedback', this.getData()).then(response => {
                    if (response.data.success) {
                        this.status = "success";
                    } else {
                        this.status = "error";
                    }
                }).catch(error => {
                    this.status = "error";
                });
            }
        }
    }

</script>
